import type { Location } from "../../../api/opb/opbTypes";

export interface OfflineDirectDebitForm {
  assetPath: string;
  filename: string;
}

// Final member-facing PDFs supplied by Finance/Ops on October 26, 2026.
export const OFFLINE_DIRECT_DEBIT_FORMS: Readonly<
  Record<string, OfflineDirectDebitForm | undefined>
> = {
  Australia: {
    assetPath: "forms/JPM Australia - Direct Debit Authorisation Form.pdf",
    filename: "JPM Australia - Direct Debit Authorisation Form.pdf",
  },
  Singapore: {
    assetPath: "forms/JPM Singapore - Giro Application Form August 2018.pdf",
    filename: "JPM Singapore - Giro Application Form August 2018.pdf",
  },
};

export function supportsOfflineDirectDebit(
  location?: Pick<Location, "country">
): boolean {
  return location?.country === "Australia" || location?.country === "Singapore";
}

export function getLocationEmail(
  location?: Pick<Location, "email">
): string | undefined {
  const email = location?.email?.trim();
  return email != null && /^[^\s@<>,;]+@[^\s@<>,;]+\.[^\s@<>,;]+$/.test(email)
    ? email
    : undefined;
}

export function getOfflineDirectDebitForm(
  location: Pick<Location, "country">,
  forms: Readonly<
    Record<string, OfflineDirectDebitForm | undefined>
  > = OFFLINE_DIRECT_DEBIT_FORMS
): OfflineDirectDebitForm | undefined {
  if (!supportsOfflineDirectDebit(location)) return undefined;
  const form = forms[location.country];
  if (
    form == null ||
    !form.assetPath.startsWith("forms/") ||
    form.assetPath.includes("..") ||
    !/\.pdf$/i.test(form.assetPath)
  )
    return undefined;
  return form;
}
